import { Autocomplete, Grid, MenuItem, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CommonTextField from "../../../../../common/components/functional/commonTextField/CommonTextField";
import AutocompleteChip from "../../../../../common/components/functional/customAutocomplete/AutocompleteChip";
import { AutocompleteType } from "../../../../../common/types/autoComplete";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";

type Props = {
  ccOptions: AutocompleteType[];
};

export const CustomerCostCenters = ({ ccOptions }: Props) => {
  const { t } = useTranslation("order");
  const { control, watch } = useFormContext();

  const { isReadOnly } = watch();

  return (
    <FormSection title={t("customerCostCenters")}>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("costCenters")}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Controller
          name="customerCostCenters"
          control={control}
          rules={{ required: true, minLength: 1 }}
          render={({ field }) => (
            <Autocomplete
              multiple
              value={field.value}
              disabled={isReadOnly}
              options={ccOptions}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderOption={(props, option) => {
                return (
                  <MenuItem
                    {...props}
                    key={option.id}
                    role={props.role}
                    id={props.id}
                    onClick={props.onClick}
                  >
                    {option.name}
                  </MenuItem>
                );
              }}
              onChange={(_, newValue) => field.onChange(newValue)}
              renderInput={(params) => (
                <CommonTextField {...params} sx={{ maxWidth: "372px" }} />
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                  const { key, ...rest } = getTagProps({ index });

                  return (
                    <AutocompleteChip key={key} {...rest} label={option.name} />
                  );
                })
              }
            />
          )}
        />
      </Grid>
    </FormSection>
  );
};
